export const DEFAULT_IDS = ["primary", "secondary", "text", "accent"];
